import React from 'react';

// import { Container } from './styles';

const EditPoint: React.FC = () => {
  return <div />;
}

export default EditPoint;